import { useState } from "react";
import Navi1CustomTable from "../Components/Navi1CustomTable";
import "../Styling/Navi1EmployeeList.css";

const Navi1EmployeeList = () => {
  const [employees] = useState([
    {
      employeeCode: "E-1001",
      name: "John",
      rank: "Captain",
      category: "Permanent",
      status: "Active",
    },
    {
      employeeCode: "E-1002",
      name: "Mary",
      rank: "Engineer",
      category: "Intern",
      status: "Active",
    },
    {
      employeeCode: "E-1003",
      name: "Robert",
      rank: "Officer",
      category: "Contract",
      status: "Active",
    },
  ]);

  const [selectedId, setSelectedId] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const columns = [
    { header: "Employee ID", accessor: "employeeCode" },
    { header: "Name", accessor: "name" },
    { header: "Rank", accessor: "rank" },
    { header: "Category", accessor: "category" },
    {
      header: "Status",
      render: (row) => <span className="StatusPill">{row.status}</span>,
    },
  ];

  console.log("selectedCategory", selectedCategory);
  const filteredData = employees.filter((emp) => {
    const idMatch = selectedId ? emp.employeeCode === selectedId : true;
    const categoryMatch = selectedCategory
      ? emp.category === selectedCategory
      : true;

    return idMatch && categoryMatch;
  });
  return (
    <div className="Navi1EmployeeListContainer">
      <div className="Header-Section">
        <h1 style={{ color: "#6990b7" }}>Onroll / Employee List</h1>

      <div className="Filters">
  <div className="DropdownWrapper teal">
    <select
      className="SearchDropdown"
      value={selectedId}
      onChange={(e) => setSelectedId(e.target.value)}
    >
      <option value="">Search by ID</option>
      <option value="E-1001">E-1001</option>
      <option value="E-1002">E-1002</option>
      <option value="E-1003">E-1003</option>
    </select>
  </div>

  <div className="DropdownWrapper orange">
    <select
      className="FilterDropdown"
      value={selectedCategory}
      onChange={(e) => setSelectedCategory(e.target.value)}
    >
      <option value="">Filter by Category</option>
      <option value="Permanent">Permanent</option>
      <option value="Intern">Intern</option>
      <option value="Contract">Contract</option>
    </select>
  </div>
</div>
      </div>

      <Navi1CustomTable columns={columns} data={filteredData} boxShadow={true} />
    </div>
  );
};

export default Navi1EmployeeList;
